import React from 'react';

import { EFontAwesomeKitIcon, FontAwesomeKitIcon } from '@feathr/components';

/** The CRM icon in the page's card headers. */
export const BLACKBAUD_ICON = <FontAwesomeKitIcon iconName={EFontAwesomeKitIcon.blackbaud} />;
